module.exports = __webpack_public_path__ + "img/6-2.e7515337.jpg";